// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"dc408482","732":"d1e72a8d","977":"47718e79"}[chunkId] + ".chunk.js");